<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import type { QuotedMessageResultDTO } from '@nora-monorepo/nora-api-client';
import { formatName } from '@nora-monorepo/shared';
import {
  bgFillQuaternary,
  textSecondary,
} from '@nora-monorepo/ui-shared';

import { urlGuardClickHandler } from '#nora-chat-ui/directives/url-guard/url-guard.directive';
import { renderMessagePreview } from '#nora-chat-ui/utils/message-markdown';

interface MessageReplyProps {
  message: QuotedMessageResultDTO;
  mine: boolean;
}

defineProps<MessageReplyProps>();
const { t } = useI18n();

function onMessagePreviewClick(event: MouseEvent): void {
  if (!(event.target instanceof Element)) {
    return;
  }

  const link = event.target.closest('a');
  if (link) {
    event.stopPropagation();
    urlGuardClickHandler(link, event);
  }
}
</script>

<template>
  <div
    class="mb-1 p-1 rounded-sm text-xs"
    :class="[
      bgFillQuaternary,
      mine ? 'text-label-on-accent-secondary' : textSecondary,
    ]"
  >
    <div class="w-full font-semibold">
      <span class="mi reply md-16 mr-1 align-text-bottom leading-5" />
      <span>
        {{ t('message.repliedTo') }}
        {{ formatName(message.sentBy) }}
      </span>
    </div>
    <div v-if="message.attachmentsCount">
      <span class="mi attach_file md-16 mr-2" /><span>{{ message.attachmentsCount }} Attachments</span>
    </div>
    <div v-if="message.deletedAt">
      <span class="mi delete mt-1 md-16 mr-0" />
      <span>{{ t('message.deleted') }}</span>
    </div>
    <div v-else class="line-clamp-2 markdown" @click="onMessagePreviewClick">
      <!-- eslint-disable vue/no-v-html -->
      <span v-html="renderMessagePreview(message.message ?? '')" />
      <!-- eslint-enable vue/no-v-html -->
    </div>
  </div>
</template>
